import { render, staticRenderFns } from "./HighSchoolForm.vue?vue&type=template&id=251fde51&"
import script from "./HighSchoolForm.vue?vue&type=script&lang=js&"
export * from "./HighSchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./HighSchoolForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HighSchoolForm.vue"
export default component.exports